import { useCallback, useEffect } from 'react';

// закрытие при нажатии вне элемента
export const useOnBlur = (ContainerRed, setActive) => {
  const handlerClose = useCallback(
    event => {
      if (ContainerRed.current) {
        const path = event?.path || event.composedPath();
        !path.includes(ContainerRed.current) && setActive(false);
      }
    },
    [ContainerRed],
  );

  useEffect(() => {
    if (ContainerRed) {
      window.addEventListener('click', handlerClose);
    }
    return () => window.removeEventListener('click', handlerClose);
  }, [ContainerRed]);
};
